import { FALSE, FILE_TYPES, FILTER_NAMES, TRUE } from "shared";

import { Files, PAYLOAD_FILE_TYPES } from "../../../types";
import { MAIN_CONFIGURATION } from "../constants";
import { FileObject } from "../types";

const useFiles = (fileValues: Files) => {
    const ftFiles: FileObject[] = [
        {
            id: PAYLOAD_FILE_TYPES.FtFirmwareFileId,
            type: [FILE_TYPES.Firmware, FILE_TYPES.FirmwareBundle],
            value: fileValues[PAYLOAD_FILE_TYPES.FtFirmwareFileId]
        },
        {
            id: PAYLOAD_FILE_TYPES.FtConfigurationFileId,
            type: FILE_TYPES.Configuration,
            value: fileValues[PAYLOAD_FILE_TYPES.FtConfigurationFileId],
            additionalParams: `${FILTER_NAMES.WebEditorSupport}=${TRUE}`,
            customFileLabel: MAIN_CONFIGURATION
        },
        {
            id: PAYLOAD_FILE_TYPES.FtOneWireAuthorizationListFileId,
            type: FILE_TYPES.OneWireAuthorizationList,
            value: fileValues[
                PAYLOAD_FILE_TYPES.FtOneWireAuthorizationListFileId
            ]
        },
        {
            id: PAYLOAD_FILE_TYPES.FtBluetoothAuthorizationListFileId,
            type: FILE_TYPES.BluetoothAuthorizationList,
            value: fileValues[
                PAYLOAD_FILE_TYPES.FtBluetoothAuthorizationListFileId
            ]
        }
    ];

    const fmxFiles: FileObject[] = [
        {
            id: PAYLOAD_FILE_TYPES.FirmwareFileId,
            type: FILE_TYPES.Firmware,
            value: fileValues[PAYLOAD_FILE_TYPES.FirmwareFileId]
        },
        {
            id: PAYLOAD_FILE_TYPES.ConfigurationFileId,
            type: FILE_TYPES.Configuration,
            value: fileValues[PAYLOAD_FILE_TYPES.ConfigurationFileId],
            additionalParams: `${FILTER_NAMES.WebEditorSupport}=${FALSE}`
        }
    ];

    const allFiles = [...ftFiles, ...fmxFiles];

    const isFileUploadedInitial = () => {
        const uniqueFileTypes = Array.from(
            new Set(
                allFiles.map(file =>
                    Array.isArray(file.type) ? file.type[0] : file.type
                )
            )
        );

        return Object.fromEntries(uniqueFileTypes.map(type => [type, false]));
    };

    return {
        ftFiles,
        fmxFiles,
        isFileUploadedInitial
    };
};

export { useFiles };
